<template>
  <div>
    <Modal v-model="modal" :title="lang=='zh'?chName.importDraft:enName.importDraft" width="760">
      <div class="center" style="padding: 0 20px">
        <Table border :loading="prevent" :columns="columns" :data="cgData">
          <template slot-scope="{ row, index }" slot="action">
            <Button type="primary" size="small" style="margin-right: 5px" @click="importClick(row, index)">{{lang=='zh'?chName.import:enName.import}}</Button >
            <Button type="error" size="small" @click="comf(row, index)">{{lang=='zh'?chName.delete:enName.delete}}</Button>
          </template>
        </Table>
      </div>
      <div slot="footer">
        <Page :total="pageInfo.itemCount" @on-change="pageChange" />
      </div>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import DateUtil from "@/util/DateUtil";
export default {
  data() {
    return {
      date: new DateUtil(),
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10,
      },
      modal: false,
      cgData: [],
      prevent: false,
      draftType: "",
      createUserId: "",
      chName:{},
      enName:{},
    };
  },
  computed: {
    //国际化监听
    lang(){
      return this.$store.getters.selectLangeData
    },
    columns() {
      return [
        {
          title: this.lang=='zh'? this.chName.no:this.enName.no,
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: this.lang=='zh'? this.chName.draftName:this.enName.draftName,
          key: "draftName",
          align: "center",
        },
        {
          title: this.lang=='zh'? this.chName.draftCreator:this.enName.draftCreator,
          key: "draftCreator",
          align: "center",
        },
        {
          title: this.lang=='zh'? this.chName.creationTime:this.enName.creationTime,
          key: "createTime",
          align: "center",
          with: 200,
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.createTime, "YYYY/MM/DD HH:mm")
            );
          },
        },
        {
          title: this.lang=='zh'? this.chName.action:this.enName.action,
          slot: "action",
          align: "center",
          width: 180,
        },
      ];
    },
  },
  methods: {
    getInternation(){
      let Obj = {
          viewType:"Common",
          beUsed : "1"
      } 
      axios.post('/International/applySelectViewSet',Obj).then((res) => {
        console.log(res)     
          this.chName= res.data[0]
          this.enName= res.data[1]
        })
    },
    comf(row, index) {
      this.$Modal.confirm({
        title:this.$notice('deletion'),
        content: "",
        onOk: () => {
          this.delectClick(row, index);
        },
        onCancel: () => {},
      });
    },
    popShow(draftType, createUserId) {
      this.modal = true;
      this.draftType = draftType;
      this.createUserId = createUserId;
      this.getTabData();
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getTabData();
    },
    importClick(row, index) {
      this.$emit("getCGDa", row);
      this.modal = false;
      this.$Message.success("导入成功");
    },
    importClick2(draftType, createUserId){
      this.draftType = draftType;
      this.createUserId = createUserId;
      this.getTabData2();
    },
    delectClick(row, index) {
      let objData = { id: row.id, }
      axios.post("/Draft/deleteDraftData", objData).then((res) => {
        if (res) {
          this.$Message.success("删除成功");
          this.getTabData();
        }
      });
    },
    getTabData() {
      this.prevent = true;
      let objData = {
        createUserId: this.createUserId,
        draftType: this.draftType,
        pageNo: this.pageInfo.pageNo,
        pageSize: 10,
      }
      axios.post("Draft/selectDraftData", objData).then((res) => {
        this.prevent = false;
        this.cgData = res.data;
        this.pageInfo.itemCount = parseInt(res.pageInfo.total);
      });
    },
    getTabData2() {
      this.prevent = true;
      let objData = {
        createUserId: this.createUserId,
        draftType: this.draftType,
        pageNo: this.pageInfo.pageNo,
        pageSize: 10,
      }
      axios.post("Draft/selectDraftData", objData).then((res) => {
        this.prevent = false;
        this.cgData = res.data;
        this.pageInfo.itemCount = parseInt(res.pageInfo.total);
        console.log(this.cgData.length)
        if(this.cgData.length >= 1){
          this.$emit("getCGDa", this.cgData[0]);
          this.$Message.success("导入成功");
        }else{
          this.$Message.error("暂无草稿");
          this.$emit("spinShowFalse");
        }
        
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/process/component/DraftTemplate.vue